import { StateCreator } from "zustand";

export interface NotificationSlice {
  notification: {
    optedIn: null | boolean;
    set: (props: Partial<NotificationSlice["notification"]>) => void;
  };
}

const createNotificationSlice: StateCreator<NotificationSlice, [], [], NotificationSlice> = (set) => ({
  notification: {
    optedIn: null,
    set: (props) => set((state) => ({ notification: { ...state.notification, ...props } })),
  },
});

export default createNotificationSlice;
